import { render, staticRenderFns } from "./make-super-admin.html?vue&type=template&id=522fd8d4&scoped=true&"
import script from "./make-super-admin.js?vue&type=script&lang=js&"
export * from "./make-super-admin.js?vue&type=script&lang=js&"
import style0 from "./make-super-admin.scss?vue&type=style&index=0&id=522fd8d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522fd8d4",
  null
  
)

export default component.exports